import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=31479dda&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31479dda')) {
      api.createRecord('31479dda', component.options)
    } else {
      api.reload('31479dda', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=31479dda&", function () {
      api.rerender('31479dda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Ij2udNXGGHIr/JS/comp/openstreetmap.vue"
export default component.exports